<div class="container">
  <h1 mat-dialog-title>
    <div class="title">You Have Been Idle!</div>
  </h1>
  <p>You are being timed-out due to inactivity. Please choose to stay signed in or to logoff.
    Otherwise, you will be logged off automatically</p>
  <p><b>{{data.idleState}}</b></p>
  <div class="btnContainer">
    <app-primary-button  class="logout" color="lightPrimary" label="Logout" (click)="logout()"></app-primary-button>
    <app-primary-button class="continue" label="Continue" (click)="continue()"></app-primary-button>
  </div>
</div>

